import { sb } from '../supabase';

// Fill profiles.phone from a managed request's contact phone — ONLY when the
// profile has none (2026-09-24). Every managed path (IdeaToProduct,
// RequestWizard, /requests managed mode) requires a phone and prefills it from
// profiles.phone; saving the first one means the trader is not asked again.
//
// NEVER overwrites. The blank test runs twice on purpose: here, against the
// profile the page holds, and again as a filter on the UPDATE itself, because
// that profile can be stale (another tab, the Settings page) and a stale
// "blank" must not become an overwrite. A row that is no longer blank simply
// does not match, and nothing is written.
//
// profiles.phone ONLY — not wa_phone_e164. That column is documented as
// DERIVED from phone, but on `profiles` nothing derives it (factory_directory
// has a sync trigger; profiles does not — see docs/TECH_DEBT.md, "profiles.phone
// and profiles.wa_phone_e164 are two independent columns"). A client write here
// would be one more hand-written source for a derived column, which is the
// drift that entry exists to close. It is left to that task.
//
// Client-writable by design: guard_profile_sensitive_fields does not cover
// `phone`, and profiles_self_update allows id = auth.uid() — the same path the
// Settings page (DashboardBuyer saveSettings) already writes it through.
//
// Returns true when the row was written. Never throws: a failure here must not
// look like a failed request, which by the time this runs already exists.
export function isBlankPhone(value) {
  return !String(value ?? '').trim();
}

export async function saveProfilePhoneIfBlank({ userId, profile, e164 }) {
  if (!userId || !e164 || !isBlankPhone(profile?.phone)) return false;
  try {
    const { data, error } = await sb.from('profiles')
      .update({ phone: e164 })
      .eq('id', userId)
      .or('phone.is.null,phone.eq.""')
      // `.select` is what tells a written row from a filtered-out one.
      .select('id');
    if (error) {
      console.error('[saveProfilePhoneIfBlank] update failed:', error.message || error);
      return false;
    }
    return Array.isArray(data) && data.length > 0;
  } catch (err) {
    console.error('[saveProfilePhoneIfBlank] update failed:', err?.message || err);
    return false;
  }
}
